<template>
  <div class="add">
    <header class="headet-title">
      <div class="headet-title-box">银行卡添加</div>
    </header>
    <div class="add-body">
      <el-form :model="addForm" ref="addForm" :rules="addFormRules" v-loading="sumbitLoading" label-width="220px" class="inputStyle">
        <el-form-item label="企业名称">
          <el-input v-model="addForm.companyName" disabled />
        </el-form-item>
        <el-form-item label="社会信用代码证">
          <el-input v-model="addForm.tradeLicenseNo" disabled />
        </el-form-item>
        <el-form-item label="账号类型">
          <el-radio-group v-model="addForm.accountType">
            <el-radio label="01">对公基本户</el-radio>
            <el-radio label="02">对公一般户</el-radio>
            <el-radio label="03">对私法人户</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="开户银行" prop="bankItem">
          <el-select v-model="addForm.bankItem" filterable value-key="bankName" placeholder="请选择输入银行" clearable @change="handBanFn($event)">
            <el-option v-for="item in bankListOption" :key="item.bankName" :label="item.bankName" :value="item" />
          </el-select>
        </el-form-item>
        <span v-if="addForm.accountType === '01' || addForm.accountType === '02'">
          <el-form-item label="开户城市" prop="bankCountiesNo">
            <Liareaselect :provinceId="addForm.bankProvNo" :cityId="addForm.bankCityNo" :areaId="addForm.bankCountiesNo" @listenPro="regAddressChange" />
          </el-form-item>
          <el-form-item label="开户支行" prop="bankBranchItem">
            <el-select v-model="addForm.bankBranchItem" filterable value-key="bankName" placeholder="请选择支行名称" clearable @change="handBranch($event)">
              <el-option v-for="item in bankbranchListOption" :key="item.id" :label="item.bankName" :value="item" />
            </el-select>
          </el-form-item>
          <el-form-item label="账号名称" prop="accountName">
            <el-input v-model="addForm.accountName" placeholder="现代支付基本户" clearable />
          </el-form-item>
          <el-form-item label="银行账号" prop="bankCardNo">
            <el-input v-model="addForm.bankCardNo" clearable />
          </el-form-item>
        </span>
        <span v-if="addForm.accountType === '03'">
          <el-form-item label="真实姓名" prop="legalName">
            <el-input v-model="addForm.legalName" clearable />
          </el-form-item>
          <el-form-item label="身份证号" prop="legalIdCard">
            <el-input v-model="addForm.legalIdCard" clearable />
          </el-form-item>
          <el-form-item label="银行卡" prop="bankCardNo">
            <el-input v-model="addForm.bankCardNo" clearable />
          </el-form-item>
          <el-form-item label="预留手机" prop="bankPhone">
            <el-input v-model="addForm.bankPhone" clearable />
          </el-form-item>
        </span>
        <span v-if="addForm.accountType === '01'">
          <el-form-item label="开户许可证或相关证明">
            <el-upload
              ref="upload"
              class="upload-demo"
              action="https://jsonplaceholder.typicode.com/posts/"
              :on-preview="handlePreview"
              :on-remove="handleRemove"
              :file-list="fileList"
              :auto-upload="false"
            >
              <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
              <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
            </el-upload>
          </el-form-item>
        </span>
        <el-form-item class="pb-50">
          <el-button type="primary" @click="submit" :loading="sumbitLoading">确定</el-button>
          <!-- <el-button type="primary" @click="printAll">打印值</el-button> -->
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import { bankCardAddBus } from '@/api/bankcard/bankcard'
import Liareaselect from '@/components/Liareaselect'
import Session from '@/utils/session'
import { getCompanyInfo } from '@/api/info'
import { addOperateLog } from '@/api/security/operateRecord'
import Common from '@/utils/common' // 工具类
import CommonApi from '@/api/common/common'
export default {
  name: 'CrossborderAddBus',
  components: {
    Liareaselect,
  },
  data() {
    return {
      sumbitLoading: false,
      addForm: {
        customerId: Session.getItem('customerId'),
        accountType: '01',
        companyName: null,
        tradeLicenseNo: null,
        bankCardNo: null,
        // 省
        bankProv: null,
        bankProvNo: null,
        // 市
        bankCity: null,
        bankCityNo: null,
        // 区
        bankCounties: null,
        bankCountiesNo: null,
        headBankName: null,
        bankBranchItem: null,
        bankBranch: null,
        bankBranchNo: null,
        accountBankNo: null,
        legalName: null,
        legalIdCard: null,
        bankPhone: null,
        source: '03',
        defaultCard: '0',
        defaultSettleCard: '0',
        bankItem: null,
        bankName: null,
        nuccCode: null,
      },
      addFormRules: {
        bankItem: [{ required: true, message: '请选择开户行', trigger: 'change' }],
        bankCountiesNo: [{ required: true, message: '请选择开户地', trigger: 'change' }],
        bankBranchItem: [{ required: true, message: '请选择开户支行', trigger: 'change' }],
        accountName: [{ required: true, message: '请输入银行账号名称', trigger: 'change' }],
        bankCardNo: [{ required: true, message: '请输入银行卡号', trigger: 'change' }],
        legalName: [{ required: true, message: '请输入姓名', trigger: 'change' }],
        legalIdCard: [{ required: true, message: '请输入身份证号', trigger: 'change' }],
        bankPhone: [{ required: true, message: '请输入银行预留手机', trigger: 'change' }],
      },
      tradeLicenseNo: null,
      bankListOption: [],
      bankbranchListOption: [],
      fileList: [],
    }
  },
  created() {
    this.bankList()
    this.getData()
  },
  watch: {
    'addForm.accountType'() {
      this.$nextTick(() => {
        this.$refs.addForm.clearValidate()
      })
    },
  },
  methods: {
    submit() {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          const param = Common.setNull({ ...this.addForm })
          this.sumbitLoading = true
          bankCardAddBus(param)
            .then((res) => {
              this.sumbitLoading = false
              this.$message.success('添加银行卡成功')

              const param = Common.setNull({
                merNo: this.$store.state.user.merNo ? this.$store.state.user.merNo : null,
                operateIp: sessionStorage.getItem('ip'),
                operateName: '添加银行卡',
                operateResult: res.code,
                remark: res.message,
              })
              addOperateLog(param)
              this.clearUp()
              this.$router.push({ name: 'CrossPay' })
            })
            .catch((error) => {
              this.sumbitLoading = false
              const param = Common.setNull({
                merNo: this.$store.state.user.merNo ? this.$store.state.user.merNo : null,
                operateIp: sessionStorage.getItem('ip'),
                operateName: '添加银行卡',
                operateResult: '9999',
                remark: error.toString(),
              })
              addOperateLog(param)
              console.log(error) // 请求失败返回的数据
            })
        }
      })
    },

    bankList() {
      const param = {
        orgType: '01',
        pageNum: 1,
        pageSize: 9999,
      }
      CommonApi.getBankList(param)
        .then((res) => {
          this.bankListOption = res.data.list
        })
        .catch((error) => {
          console.log(error) // 请求失败返回的数据
        })
    },
    // 获取企业基本信息
    getData() {
      const param = {
        customerId: this.addForm.customerId,
      }
      this.sumbitLoading = true
      getCompanyInfo(param)
        .then((res) => {
          this.sumbitLoading = false
          this.addForm.companyName = res.data.companyName
          this.addForm.tradeLicenseNo = res.data.tradeLicenseNo
          this.addForm.legalName = res.data.corporationName
          this.addForm.legalIdCard = res.data.corporationIdCardNo
        })
        .catch((error) => {
          this.sumbitLoading = false
          console.log(error) // 请求失败返回的数据
        })
    },

    handBanFn(data) {
      console.log('获得的银行数据', data)
      this.addForm.bankName = data.bankName
      this.addForm.nuccCode = data.nuccCode
      this.addForm.accountBankNo = data.bankCode

      // 如果用户修改开户银行，则再去查询一次开户支行
      if (this.addForm.bankProv && this.addForm.bankCity && this.addForm.bankCounties) {
        this.getBranchBankList()
      }
    },

    handBranch(data) {
      this.addForm.bankBranch = data.bankName
      this.addForm.bankBranchNo = data.bankNo
    },

    regAddressChange(data) {
      // console.log('获取的', data)
      this.addForm.bankProv = data.province.name
      this.addForm.bankProvNo = data.province.id

      this.addForm.bankCity = data.city.name
      this.addForm.bankCityNo = data.city.id

      this.addForm.bankCounties = data.area.name
      this.addForm.bankCountiesNo = data.area.id

      if (this.addForm.bankProv && this.addForm.bankCity && this.addForm.bankCounties) {
        this.getBranchBankList()
      }
    },

    getBranchBankList() {
      if (!this.addForm.nuccCode || !this.addForm.accountBankNo) {
        this.$message.error('请先选择开户银行')
        return
      }

      if (!this.addForm.bankCity || !this.addForm.bankCounties) {
        this.$message.error('请先选择开户城市')
      }

      this.addForm.bankBranch = null
      this.addForm.bankBranchNo = null
      this.addForm.bankBranchItem = null
      this.$nextTick(() => {
        this.$refs.addForm.clearValidate()
      })

      const param = Common.setNull({
        pageNum: 1,
        pageSize: 9999,
        headBankCode: this.addForm.accountBankNo,
        headBankName: this.addForm.bankName,
        nuccCode: this.addForm.nuccCode,
        provinceName: this.addForm.bankProv,
        cityName: this.addForm.bankCity,
      })
      CommonApi.getBranchBankList(param)
        .then((res) => {
          this.addForm.bankBranch = null
          this.bankbranchListOption = res.data.list
        })
        .catch((error) => {
          console.log(error) // 请求失败返回的数据
        })
    },

    handlePreview() {},
    handleRemove() {},

    clearUp() {
      // 应为getData对应的值，不能去掉，所以只能一个一个赋值上去了
      this.addForm.accountType = '01'
      this.addForm.bankCardNo = null
      this.addForm.bankProv = null
      this.addForm.bankProvNo = null
      this.addForm.bankCity = null
      this.addForm.bankCityNo = null
      this.addForm.bankCounties = null
      this.addForm.bankCountiesNo = null
      this.addForm.headBankName = null
      this.addForm.bankBranchItem = null
      this.addForm.bankBranchNo = null
      this.addForm.accountBankNo = null
      this.addForm.bankPhone = null
      this.addForm.bankItem = null
      this.addForm.bankName = null
      this.addForm.nuccCode = null
      this.addForm.accountName = null

      this.$nextTick(() => {
        this.$refs.addForm.clearValidate()
      })
    },

    printAll() {
      console.log('this.addForm', this.addForm)
      console.log('this.bankListOption', this.bankListOption)
      console.log('this.bankbranchListOption', this.bankbranchListOption)
    },
  },
}
</script>
<style>
.bN .el-input__inner {
  border: none;
}
</style>
<style scoped>
.headet-title {
  padding: 10px 30px 20px 30px;
}
.headet-title .headet-title-box {
  font-size: 16px;
  padding: 10px 0;
  border-bottom: 1px solid #dbdde2;
}

::v-deep .inputStyle .el-form-item__content {
  width: 400px;
}
::v-deep .el-select {
  width: 100%;
}

.w200 {
  width: 200px;
}
.w210 {
  width: 210px;
}
.color6 {
  color: #828282;
}
.fz12 {
  font-size: 12px !important;
}
.pb-50 {
  padding-bottom: 50px;
}
.linkBy .el-form-item__content {
  margin-left: 0;
}
</style>
